<template lang="pug">
.fb-columns-block(:class="{ 'is-selected': block.id === selectedId }")
    .fb-columns-bar(:class="{ 'fb-handle': edit }" @click.stop="$emit('select', block)")
        .fb-columns-grip(v-if="edit")
            i.el-icon-fa-grip-vertical.fas
        i.fb-columns-icon.el-icon-fa-table-columns.fas
        span.fb-columns-title {{ title }}
        el-button.fb-columns-delete(
            v-if="edit"
            circle
            size="mini"
            type="danger"
            icon="el-icon-fa-trash-can fas"
            @click.stop="$emit('delete', block)"
        )
    .fb-columns-grid(
        :style="{ gridTemplateColumns: `repeat(${block.children.length}, 1fr)` }"
        @mousedown.stop
    )
        form-builder-cell(
            v-for="(column, ci) in block.children"
            :key="ci"
            :list="column"
            :selected-id="selectedId"
            :edit="edit"
            :options="options"
            @change="$emit('change')"
            @select="$emit('select', $event)"
            @delete="$emit('delete', $event)"
        )
</template>

<i18n>
{
    "en": { "Two columns": "Two columns", "Three columns": "Three columns" },
    "de": { "Two columns": "Zweispalter", "Three columns": "Dreispalter" }
}
</i18n>

<script>
import FormBuilderCell from './FormBuilderCell'

export default {
    name: 'FormBuilderColumns',
    components: { FormBuilderCell },
    props: {
        block: { type: Object, required: true },
        selectedId: { type: String, default: null },
        edit: { type: Boolean, default: true },
        options: { type: Object, default: () => ({}) },
    },
    computed: {
        title() {
            return this.block.children.length === 3 ? this.$t('Three columns') : this.$t('Two columns')
        },
    },
}
</script>

<style lang="sass" scoped>
// Layout containers are set apart from plain fields: accent border, tinted
// header, inset background and a soft shadow so they read as a sub-section.
.fb-columns-block
    border: 1px solid #d8dce5
    border-left: 3px solid $--color-primary
    border-radius: 8px
    background: #eef1f6
    box-shadow: 0 1px 3px rgba(0, 0, 0, .06)
    &.is-selected
        border-color: $--color-primary
        box-shadow: 0 0 0 1px $--color-primary
.fb-columns-bar
    display: flex
    align-items: center
    gap: .45rem
    padding: .35rem .6rem
    cursor: grab
    background: rgba($--color-primary, .08)
    border-bottom: 1px solid #dce0e8
    border-radius: 5px 5px 0 0
    &:active
        cursor: grabbing
.fb-columns-grip
    color: #c0c4cc
    font-size: .8rem
.fb-columns-icon
    color: $--color-primary
    font-size: .85rem
.fb-columns-title
    flex: 1 1 auto
    font-size: .72rem
    font-weight: 700
    text-transform: uppercase
    letter-spacing: .03em
    color: $--color-primary
.fb-columns-grid
    display: grid
    gap: .5rem
    padding: .6rem
</style>
